/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosResponse } from 'axios';
import { InfoNotification } from '../../../app.notification';
import { AxiosErrorResponse } from '../../../app.settings';

import api from '../../../axios';
import { IOrgaoEmissor } from './model';

export async function getById(usuarioId: string): Promise<IOrgaoEmissor | any> {
  try {
    const { data } = await api.get<AxiosResponse<IOrgaoEmissor>>('/orgao_emissor/' + usuarioId);
    return data as unknown as IOrgaoEmissor;
  } catch (error: any) {
    AxiosErrorResponse(error);
  }
}
export async function getAll(): Promise<IOrgaoEmissor[] | undefined> {
  try {
    const { data } = await api.get<AxiosResponse<IOrgaoEmissor[]>>('/orgao_emissor');
    return data as unknown as IOrgaoEmissor[];
  } catch (error: any) {
    AxiosErrorResponse(error);
  }
}

export async function update(usuario: Partial<IOrgaoEmissor>): Promise<IOrgaoEmissor | any> {
  try {
    const { data } = await api.put<AxiosResponse<IOrgaoEmissor>>('/orgao_emissor/' + usuario.id, {
      ...usuario,
    });
    return (data as unknown as IOrgaoEmissor[])[0];
  } catch (error: any) {
    AxiosErrorResponse(error);
  }
}

export async function insert(usuario: IOrgaoEmissor): Promise<IOrgaoEmissor | any> {
  try {
    const { data } = await api.post<AxiosResponse<IOrgaoEmissor>>('/orgao_emissor/', {
      ...usuario,
    });
    return (data as unknown as IOrgaoEmissor[])[0];
  } catch (error: any) {
    AxiosErrorResponse(error);
  }
}

export async function save(usuario: IOrgaoEmissor): Promise<IOrgaoEmissor | any> {
  try {
    if (usuario.id) {
      return await update(usuario).then(() => {
        InfoNotification('Registro alterado!');
      });
    } else {
      return await insert(usuario).then(() => {
        InfoNotification('Registro criado!');
      });
    }
  } catch (error: any) {
    AxiosErrorResponse(error);
  }
}

export async function remove(usuarioId: string): Promise<IOrgaoEmissor | any> {
  try {
    return await api
      .delete<AxiosResponse<IOrgaoEmissor>>('/orgao_emissor/' + usuarioId)
      .then(() => {
        InfoNotification('Registro excluido!');
      });
  } catch (error: any) {
    AxiosErrorResponse(error);
  }
}
